import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import Loader from "../../../../loader/Loader";
import AxiosController from "../../../../authentication/AxiosController";
import StatisticsSearchComponent from "../search components/StatisticsSearchComponent";
import { Button, Table } from "react-bootstrap";

const SellersProducts = () => {
  const { slug, lang } = useParams();
  const { t } = useTranslation("global");
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [openDropdown, setOpenDropdown] = useState({});
  const [allData, setAllData] = useState([]);
  const [search, setSearch] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [productId, setProductId] = useState("");
  const [sellerId, setSellerId] = useState("");
  const [categoryIds, setCategoryIds] = useState("");
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);

  const toggleDropdown = (index) => {
    setOpenDropdown((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const getProductsOverview = () => {
    setLoading(true);
    AxiosController.get(
      `api/${slug}/${lang}/reports/products-overview?with_sellers=1`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          start_date: startDate,
          end_date: endDate,
          product_id: productId,
          seller_id: sellerId,
          category_ids: categoryIds,
        },
      }
    )
      .then((res) => {
        setLoading(false);
        setAllData(res?.data?.products || []);
      })
      .catch(() => setLoading(false));
  };
  useEffect(() => {
    setProductId(urlParams.get("product_id") || "");
    setSellerId(urlParams.get("seller_id") || "");
    setCategoryIds(urlParams.get("category_ids") || "");
    setStartDate(urlParams.get("start_date") || "");
    setEndDate(urlParams.get("end_date") || "");
  }, [urlParams]);

  useEffect(() => {
    getProductsOverview();
  }, [startDate, endDate, productId, sellerId, categoryIds]);

  return (
    <div className="flex-grow-1 stats-component py-3">
      <Button
        className="fs-5 w-25 mb-4 align-self-start"
        style={{
          backgroundColor: "rgb(89, 198, 201)",
          border: "none",
          borderRadius: "7px",
        }}
        onClick={() => setSearch(!search)}
      >
        {t("panel.search")}
      </Button>
      {search && <StatisticsSearchComponent type={"seller_products"} />}

      <div className="reports-container my-3 d-flex flex-column gap-2 px-2 position-relative">
        <Loader active={loading} />

        <div className="row" style={{ height: "1200px" }}>
          <div
            className="col-12"
            style={{ position: "relative", overflowX: "auto", height: "100%" }}
          >
            <Table>
              <thead>
                <tr className="text-center">
                  <th className="text-nowrap">{t("panel.productTitle")}</th>
                  <th className="text-nowrap">{t("panel.stock")}</th>
                  <th className="text-nowrap">{t("panel.total_orders")}</th>
                  <th className="text-nowrap">{t("panel.pending")}</th>
                  <th className="text-nowrap">{t("panel.shipped")}</th>
                  <th className="text-nowrap">{t("panel.delivered")}</th>
                  <th className="text-nowrap">{t("panel.seller")}</th>
                  <th className="text-nowrap">{t("panel.marketers")}</th>
                  <th className="text-nowrap">{t("panel.sys_commission")}</th>
                  <th className="text-nowrap">{t("panel.seller_commission")}</th>
                  <th className="text-nowrap">{t("panel.marketer_commission")}</th>
                </tr>
              </thead>
              <tbody>
                {allData.length > 0 &&
                  allData.map((item, index) => {
                    const totalOrders = Number(item?.total_orders_count);
                    const totalQuantity = Number(item?.total_quantity);
                    const shippedOrders = Number(item?.shipped_count);
                    const shippedQuantity = Number(item?.shipped_quantity);
                    const deliveredOrders = Number(item?.delivered_cash_delivery_count);
                    const deliveredQuantity = Number(item?.delivered_cash_delivery_quantity);
                    const pendingOrders = Number(item?.pending_count);

                    return (
                      <tr className="text-center" key={item?.id}>
                        <td className="text-start">
                          <div className="d-flex flex-column text-center">
                            <span className="fw-bold">#{item?.id}</span>
                            <span>{item?.title}</span>
                          </div>
                        </td>
                        <td>
                          <span className="fw-bold">{Number(item?.stock_quantity).toLocaleString()}</span>
                        </td>
                        <td>
                          <div className="d-flex flex-column">
                            <span>{totalOrders.toLocaleString()} {t("panel.orders")}</span>
                            <span>{totalQuantity.toLocaleString()} {t("panel.quantity")}</span>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex flex-column">
                            <span>{pendingOrders.toLocaleString()} {t("panel.orders")}</span>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex flex-column">
                            <span className="text-primary">{((shippedOrders / totalOrders) * 100).toFixed(1)}%</span>
                            <span>{shippedOrders.toLocaleString()} {t("panel.orders")}</span>
                            <span>{shippedQuantity.toLocaleString()} {t("panel.quantity")}</span>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex flex-column">
                            <span className="text-success">{((deliveredOrders / totalOrders) * 100).toFixed(1)}%</span>
                            <span>{deliveredOrders.toLocaleString()} {t("panel.orders")}</span>
                            <span>{deliveredQuantity.toLocaleString()} {t("panel.quantity")}</span>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex flex-column">
                            <span className="fw-bold">#{item?.seller?.id}</span>
                            <span>{item?.seller?.first_name} {item?.seller?.last_name}</span>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex flex-column">
                            {item?.marketers?.length > 0 ? (
                              item.marketers.map((marketer, idx) => (
                                <span key={idx}>
                                  #{marketer.id} - {marketer.first_name} {marketer.last_name}
                                </span>
                              ))
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </div>
                        </td>
                        <td>
                          <span className="fw-bold">{Number(item?.total_sys_commission).toLocaleString()}</span>
                        </td>
                        <td>
                          <span className="fw-bold">{Number(item?.total_seller_commission).toLocaleString()}</span>
                        </td>
                        <td>
                          <span className="fw-bold">{Number(item?.total_marketer_commission).toLocaleString()}</span>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SellersProducts;
